/******************************************************************************
 *
 * Copyright (c) 2019-2022 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Shivam Mishra' <shivam.mishra@wakencode.com>, September 2022
 *
 *****************************************************************************/

/**
 * This is a constant font-family file, all the font-family used in webapp are rest here
 */
export const FONT_FAMILY = {
  FONT_FAMILY_REGULAR: "Avenir-Next-LT-Pro-Regular",
  FONT_FAMILY_BOLD: "Avenir-Next-LT-Pro-Bold",
  FONT_FAMILY_DEMI: "Avenir-Next-LT-Pro-Demi",
  FONT_FAMILY_ITALIC: 'Avenir-Next-LT-Pro-Italic'
};
